import { render } from "./PageParametroTAF.vue?vue&type=template&id=a97212d0&scoped=true"
import script from "./PageParametroTAF.vue?vue&type=script&lang=js"
export * from "./PageParametroTAF.vue?vue&type=script&lang=js"

import "./PageParametroTAF.vue?vue&type=style&index=0&id=a97212d0&scoped=true&lang=css"
/* custom blocks */
import block0 from "./PageParametroTAF.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97212d0"]])

export default __exports__